export default "__VITE_ASSET__DDlCdANs__"